import { RouteObject } from "react-router-dom";
import LegacyIFrame from "../pages/Legacy/LegacyIFrame";

export const adminLegacyPaths = [
  "/dashboard.asp",
  "/wsg_preview_new.asp",
  "/wsg_firmprofessionals.asp",
  "/manage_publications.asp",
  "/manage_releases.asp",
  "/manage_blogrolls.asp",
  "/history.asp",
  "/manage_practiceheads.asp",
  "/manage_secondments.asp",
  "/manage_dealmaker.asp",
  "/business-guide-upload",
  "/manage_dealmaker.asp",

];

const generateLegacyRoutes = (paths: string[]): RouteObject[] => {
  return paths.map((path) => ({
    path,
    element: <LegacyIFrame />,
  }));
};

export const AdminLegacyRoutes: RouteObject[] =
  generateLegacyRoutes(adminLegacyPaths);
